interface Page {
  id: string | number;
  name: string;
}

interface VideoDetailsButtonProps {
  pages: Page;
  isSelected: string | number | undefined;
  setIsSelected: (id?: string | number) => void;
  selected: boolean;
  setComponents: (pages: Page) => void;
}

function VideoDetailsButton({
  pages,
  isSelected,
  setIsSelected,
  selected,
  setComponents,
}: VideoDetailsButtonProps) {
  const handleSelect = () => {
    if (isSelected === pages.id) {
      setIsSelected();
    } else {
      setIsSelected(pages.id);
    }
    setComponents(pages);
  };

  return (
    <button
      type="button"
      role="tab"
      aria-selected={selected}
      onClick={handleSelect}
      className={`font-urbanist group relative my-1 flex h-10 min-w-[120px] items-center justify-center px-3 text-[15px] font-medium transition-colors duration-200 max-sm:px-2 ${
        selected ? "text-[var(--red)]" : "text-white/65 hover:text-white"
      }`}
    >
      {pages.name}
      <span
        aria-hidden="true"
        className={`absolute inset-x-3 bottom-0 h-[2px] origin-left rounded-full bg-[var(--red)] transition-transform duration-200 ease-out ${
          selected
            ? "scale-x-100"
            : "scale-x-0 group-hover:scale-x-100 group-hover:bg-white/40"
        }`}
      />
    </button>
  );
}

export default VideoDetailsButton;